import request from './request';

export function createPostShared(id, type, data) {
    return request('post', `/apiv2/${type}/${id}/post-shared`, data);
}
